// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jrXy","name":"styles_name__3dbrt","phone":"styles_phone__2eaR6"};